<template>
  <b-overlay :show="loading">
    <section>
      <div class="d-flex justify-content-between align-items-center mb-1">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click.prevent="$router.push({ name: 'penerimaan-barang' })"
        >
          <feather-icon icon="ArrowLeftIcon" class="mr-50" />
          Kembali
        </b-button>
        <b-button
          v-if="pb.selesai == 0"
          variant="primary"
          @click.prevent="$router.push({ name: 'penempatan', query: { no_inv: pb.no_invoice } })"
        >
          <span class="align-middle">Tempatkan Barang</span>
          <feather-icon icon="ChevronRightIcon" class="ml-1" />
        </b-button>
      </div>

      <b-card class="mb-2">
        <b-row>
          <b-col cols="12" class="mb-1">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <div>
                <small class="text-muted d-block">No. Invoice</small>
                <h4 class="mb-0">{{ pb.no_invoice || "-" }}</h4>
              </div>
              <b-badge
                :variant="pb.selesai == 1 ? 'success' : 'danger'"
                class="mt-50"
              >
                {{ pb.selesai == 1 ? "Selesai" : "Belum ditempatkan" }}
              </b-badge>
            </div>
          </b-col>
          <b-col md="3" sm="6" class="mb-1">
            <small class="text-muted d-block">Tanggal Invoice</small>
            <strong>{{ humanDate(pb.tanggal_invoice) }}</strong>
          </b-col>
          <b-col md="3" sm="6" class="mb-1">
            <small class="text-muted d-block">Tanggal Penerimaan</small>
            <strong>{{ humanDate(pb.tanggal_penerimaan) }}</strong>
          </b-col>
          <b-col md="3" sm="6" class="mb-1">
            <small class="text-muted d-block">Gudang</small>
            <strong>
              {{ pb.gudang && pb.gudang.nama_gudang ? pb.gudang.nama_gudang : "-" }}
            </strong>
          </b-col>
          <b-col md="3" sm="6" class="mb-1">
            <small class="text-muted d-block">Keterangan</small>
            <strong>{{ pb.keterangan ? pb.keterangan : "-" }}</strong>
          </b-col>
          <b-col md="3" sm="6" class="mb-1">
            <small class="text-muted d-block">Total Item</small>
            <strong>{{ pb.total_rincian != null ? pb.total_rincian : barangs.length }}</strong>
          </b-col>
          <b-col md="3" sm="6" class="mb-1">
            <small class="text-muted d-block">Total Jumlah</small>
            <strong>{{ formatRupiah(pb.total_jumlah != null ? pb.total_jumlah : 0) }}</strong>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <h5 class="mb-1">Daftar Barang Yang Diterima</h5>
        <b-table
          v-if="barangs.length > 0"
          striped
          hover
          responsive
          :items="barangs"
          :fields="barangFields"
        >
          <template #cell(no)="row">
            {{ row.index + 1 }}
          </template>
          <template #cell(barang)="{ item }">
            {{ item.barang ? item.barang.nama : "-" }}
          </template>
          <template #cell(jumlah)="{ item }">
            {{ formatRupiah(item.jumlah) }}
            <span v-if="item.barang && item.barang.satuan" class="text-muted">
              {{ item.barang.satuan.satuan }}
            </span>
          </template>
          <template #cell(no_container)="{ item }">
            {{ item.no_container || "-" }}
          </template>
          <template #cell(no_seal)="{ item }">
            {{ item.no_seal || "-" }}
          </template>
        </b-table>
        <p v-else class="text-muted mb-0 text-center py-2">
          Belum ada rincian barang.
        </p>
      </b-card>
    </section>
  </b-overlay>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BBadge,
  BButton,
  BTable,
  BOverlay,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BBadge,
    BTable,
    BOverlay,
  },
  data: () => ({
    loading: false,
    pb: {
      no_invoice: null,
      tanggal_invoice: null,
      tanggal_penerimaan: null,
      keterangan: null,
      selesai: null,
      total_rincian: null,
      total_jumlah: null,
      gudang: null,
    },
    barangFields: [
      { key: "no", label: "No" },
      { key: "barang", label: "Nama Barang" },
      { key: "jumlah", label: "Jumlah" },
      { key: "no_container", label: "No. Container" },
      { key: "no_seal", label: "No. Seal" },
    ],
    barangs: [],
  }),
  methods: {
    async getPb() {
      const pb = await this.$store.dispatch(
        "penerimaan-barang/getDataById",
        this.$route.params.id
      );
      this.pb = pb || this.pb;
    },
    async getBarangPb() {
      const barangs = await this.$store.dispatch(
        "penerimaan-barang/getDataBarang",
        {
          penerimaan_id: this.$route.params.id,
        }
      );
      this.barangs = barangs || [];
    },
  },
  async created() {
    this.loading = true;
    try {
      await Promise.all([this.getPb(), this.getBarangPb()]);
    } catch (e) {
      this.displayError(e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
